import { initLayout } from './layout.config'

initLayout()
